<template>
   <b-col>
        <b-row>
            <h3 class="ml-3">Request Job zurücksetzen</h3>
        </b-row>
        <b-row class="my-2">
            <b-col>
                <b-form-input v-model="ean" placeholder="EAN"></b-form-input>
            </b-col>
            <b-col class="col-2 ml-2 pl-1">
                <b-col/>
                <b-col class="p-0">
                <b-button block size="md" @click="execute()" variant="primary">zurücksetzen</b-button>
                </b-col>
                <b-col/>
            </b-col>
        </b-row>
    </b-col>
</template>
<script>
export default {
    name: 'requestJobReset',
    data() {
        return {
            ean: "",
            regexEanPattern: new RegExp('^[0-9]{12,13}$')
        }
    },
    methods: {
        validateEan() {
            if(this.ean == null || this.ean.length == 0) return false;
            return this.regexEanPattern.test(this.ean) && (this.ean.length === 10);
        },
        execute() {
            if(!this.validateEan()) {
                this.$bvToast.toast( "Ungültige EAN, die Anfrage wird dennoch durchgeführt.", {
                    title: "Request Job Resetter",
                    autoHideDelay: 3000,
                    appendToast: false,
                    variant: 'info'
                });
            }

            axios.get(`mds/request_job/reset/${ean}`).then( response => {
                this.$bvToast.toast( "Request Job wurde erfolgreich zurückgesetzt.", {
                    title: "Request Job Resetter",
                    autoHideDelay: 8000,
                    appendToast: false,
                    variant: 'success'
                });
            }).catch( error => {
                console.error(error);
                if(error.response.status == 406) {
                    this.$bvToast.toast( error.response.data, {
                        title: "Request Job Resetter",
                        autoHideDelay: 8000,
                        appendToast: false,
                        variant: 'danger'
                    });
                }else{
                    this.$bvToast.toast( "etwas unerwartetes ist schiefgegangen.", {
                        title: "Request Job Resetter",
                        autoHideDelay: 8000,
                        appendToast: false,
                        variant: 'danger'
                    });
                }
            });
        }
    }
}
</script>
